import gql from 'graphql-tag';
import { GetTicketsByJobIdQuery } from './jobTicketsApi';

const DeleteTicketMutation = gql`
  mutation DeleteTicket($input: TicketDestroyInput!) {
    ticket_destroy(input: $input)
  }
`;


export const deleteTicketApi = async (client, ticketId, jobId) => {
  const variables = {
    input: {
      id: ticketId,
    },
  };

  const options = {
    mutation: DeleteTicketMutation,
    variables,

    refetchQueries: [
      {
        query: GetTicketsByJobIdQuery,
        variables: {
          jobId,
        },
      },
    ],

  };

  const result = await client.mutate(options);
  return {
    result,
  };
};
